import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

import colors from '../../theme/partials/colors';
import { buttonStyle } from './index';

export const PanelContainer = styled.div`
  position: fixed;
  bottom: 0%;
  left: 0%;
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: ${props => props.theme.colors.backgroundOpacity};
  z-index: 10;
  min-height: ${pxToRem('90px')};
  align-items: center;
  border-top-left-radius: ${pxToRem('16px')};
  border-top-right-radius: ${pxToRem('16px')};
  justify-content: space-between;
  padding: 0 ${pxToRem('30px')} 0 ${pxToRem('146px')};
`;

export const ItemsContainer = styled.div`
  min-width: ${pxToRem('300px')};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  @media ${({ theme }) => theme.device.laptop} {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 42%;
  justify-content: flex-end;
  padding: ${pxToRem('10px')} ${pxToRem('0px')};
  flex: 1;
`;

export const ItemContainer = styled.div`
  text-transform: uppercase;
`;

export const IconWrapper = styled.div`
  width: ${pxToRem('18px')};
  height: ${pxToRem('18px')};
  border-radius: 50%;
  border: ${pxToRem('2px')} solid ${props => props.theme.colors.blue.one};
  margin-right: ${pxToRem('10px')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: ${pxToRem('2px')} ${pxToRem('2px')} ${pxToRem('4px')} 0
    rgba(0, 0, 0, 0.08);
  background-image: linear-gradient(135deg, #7cb2fd, #467afb);
`;

export const TooltipText = styled.span`
  font-family: OpenSans;
  padding: ${pxToRem('3px')} ${pxToRem('6px')} ${pxToRem('3px')} 0;
  font-size: ${pxToRem('14px')};
  line-height: 1.33;
  display: flex;
  flex-direction: row;
  align-content: baseline;
  justify-content: flex-start;
  flex-wrap: nowrap;
`;

export const TooltipTextStatus = styled.span`
  height: ${pxToRem('28px')};
  font-size: ${pxToRem('12px')};
  font-weight: bold;
  text-transform: uppercase;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: ${pxToRem('2px')};
  text-align: center;
  padding: ${pxToRem('6px')} ${pxToRem('11px')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${pxToRem('20px')};
  margin: 0 ${pxToRem('6px')};

  ${props =>
    props.type === buttonStyle.ENABLE &&
    css`
      height: ${pxToRem('20px')};
      background: ${colors().statusBgGreen};
      //background: rgba(0,173,62,0.16);
      color: ${colors().statusText};
    `}
  ${props =>
    props.type === buttonStyle.DISABLE &&
    css`
      height: ${pxToRem('20px')};
      background: ${colors().greyBg};
      //background: rgba(0,173,62,0.16);
      color: ${colors().darkGray};
    `}
`;

export const RFIDButtonContainer = styled(ButtonContainer)`
  justify-content: flex-end;
`;
